import s from "./style.module.css"

export function Hr({ children }) {
  return <div className={s.separator}>{children}</div>;
}